import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Category from '@mui/icons-material/Category';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getpurchase } from '../redux/purchase';
import Progress from '../components/Loader';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [unit, setUnit] = React.useState('none');
  const [warehouse, setWarehouse] = React.useState(props.chosen.warehousereceived || 'none');
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();
  const warehouses = useSelector((state) => state.warehouse || []);

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    setUnit('none');
    setWarehouse('none');
    document.getElementById('qty').value = '';
    document.getElementById('date').value = '';
  };

  const receiveGoods = async () => {
    setLoading(true);
    const qtyReceived = parseFloat(document.getElementById('qty').value) || 0;
    const previousQty = parseFloat(props.chosen.qtyreceived) || 0;
    const totalQty = previousQty + qtyReceived;

    try {
      const res = await axios.post('https://server.agrotraciserp.com/api/purchase/editpurchase/', {
        datereceived: document.getElementById('date').value,
        unitqty: unit,
        qtyreceived: totalQty,
        status: 'Received',
        id: props.chosen.id,
        warehousereceived: warehouse,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getpurchase({ data: res.data }));
        setSnackbarMessage('Goods received successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to receive goods.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error receiving goods.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Receive Goods at Warehouse
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '100%' }, '& .MuiFormControl-root': { m: 1, width: '100%' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="qty"
              label="Quantity Received"
              type="number"
              autoComplete="current-text"
              sx={{ mb: 2, mt: 1 }}
            />
            <FormControl sx={{ mb: 2, mt: 1 }}>
              <InputLabel id="unit-select-label">Select Unit</InputLabel>
              <Select
                labelId="unit-select-label"
                id="unit-select"
                value={unit}
                label="Select Unit"
                onChange={(e) => setUnit(e.target.value)}
              >
                <MenuItem value="none">Choose unit</MenuItem>
                <MenuItem value="Bags">Bags</MenuItem>
                <MenuItem value="Kg">Kg</MenuItem>
                <MenuItem value="Tons">Tons</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ mb: 2, mt: 1 }}>
              <InputLabel id="warehouse-select-label">Choose Warehouse</InputLabel>
              <Select
                labelId="warehouse-select-label"
                id="warehouse-select"
                value={warehouse}
                label="Choose Warehouse"
                onChange={(e) => setWarehouse(e.target.value)}
              >
                <MenuItem value="none">Choose</MenuItem>
                {warehouses.map((list) => (
                  <MenuItem key={list.warehousename} value={list.warehousename}>
                    {list.warehousename}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="date"
              label="Date Received"
              type="date"
              required
              autoComplete="current-text"
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2, mt: 1 }}
            />
            <List sx={{ width: '100%' }}>
              <ListItem>
                <ListItemText primary={props.chosen.batch || 'N/A'} secondary="Batch Number" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.agent || 'N/A'} secondary="Agent Name" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.amount || 'N/A'} secondary="Amount Given" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.expectedSupplyDate || 'N/A'} secondary="Expected Supply Date" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.product || 'N/A'} secondary="Product(s)" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.qty || 'N/A'} secondary="Quantity Pre-financed" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.datePrefinanced || 'N/A'} secondary="Date Pre-financed" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.otherInfo || 'N/A'} secondary="Other Information" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.haullier || 'N/A'} secondary="Haullier" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.vehicleNumber || 'N/A'} secondary="Vehicle Number" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.qtyReceivedByHaullier || 'N/A'} secondary="Quantity Received By Haullier" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.waybillNumber || 'N/A'} secondary="Waybill Number" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={`${props.chosen.rawqty || '0'} ${props.chosen.unitqty || ''}`} secondary="Quantity Of Raw Materials" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={`${props.chosen.finishqty || '0'} ${props.chosen.unitqty || ''}`} secondary="Quantity Of Finished Goods" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.dateDispatched || 'N/A'} secondary="Date Dispatched" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.costOfTransport || 'N/A'} secondary="Cost Of Transport" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.warehouseStored || 'N/A'} secondary="Warehouse Stored" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText primary={props.chosen.otherDescriptions || 'N/A'} secondary="Other Descriptions" />
              </ListItem>
              <Divider />
            </List>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<Category />} size="large" onClick={receiveGoods}>
                Receive
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}